import { useLazyQuery } from '@apollo/client';
import useEnableFastifyApi from './useEnableFastifyApi';
import { FLIGHT_PROFILE_EMAIL } from '../queries';
import restRequest from './restClient';
import useAsyncCall from './useAsyncCall';

function toGraphqlShape(bffResponse) {
  return {
    flightProfile: {
      guests: bffResponse?.flightProfile?.guests?.map((guest) => ({ email: guest.email })) ?? [],
    },
  };
}

export default function useFlightProfileEmail(options) {
  const enableFastifyApi = useEnableFastifyApi();

  const graphqlResult = useLazyQuery(FLIGHT_PROFILE_EMAIL, options);
  const [restExecute, restState] = useAsyncCall(
    () => restRequest({ path: '/air-api/v1/profile/full' }).then(toGraphqlShape),
    options,
  );

  if (enableFastifyApi) {
    return [restExecute, restState];
  }
  return graphqlResult;
}
